import Vue from 'vue'
import i18n from '@/scripts/app-configs/i18n-config'

/**
 * Sort plain or objects array alphabetically filter
 * @name SortAlphabetically Utils filter
 * @returns {array} Alphabetically sorted Array
 */

const sortAlphabetically = (arrayToSort, sortByKey) => {

  const isSortable = Array.isArray(arrayToSort)
  const plainStrArray = isSortable && arrayToSort.every((element) => typeof element === 'string')

  if (!isSortable || (!plainStrArray && !sortByKey)) {
    console.warn('[sort-alpha-filter] Unable to alphabetically sort provided source')

    return arrayToSort
  }

  return arrayToSort.sort((a, b) => {
    const aVal = plainStrArray ? a : a[sortByKey] || ''
    const bVal = plainStrArray ? b : b[sortByKey] || ''

    return i18n.t(aVal).localeCompare(i18n.t(bVal))
  })
}

Vue.filter('sortAlphabetically', sortAlphabetically)

export default sortAlphabetically
